import { ACCESS_TOKEN_EXPIRATION_TIME, SAME_SITE_STRICT } from '@constants/cookies';
import { IS_DEV_NODE_ENV } from '@constants/nodeEnvs';
import Cookies from 'js-cookie';

import {
  ACCESS_TOKEN_KEY,
  IMPERSONATE_ACCESS_TOKEN_KEY,
  IMPERSONATE_REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  STORAGE_ACCESS_TOKEN_KEY,
  STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY,
  STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY,
  STORAGE_REFRESH_TOKEN_KEY,
} from './constants';

const cookieDomain = IS_DEV_NODE_ENV ? 'localhost' : '.xceed.me';

const maxDaysRefreshToken = 90;

const removeLocalStorageToken = (key: string) => {
  if (globalThis.window !== undefined && key) localStorage.removeItem(key);
};

const removeSessionStorageToken = (key: string) => {
  if (globalThis.window !== undefined && key) sessionStorage.removeItem(key);
};

export const removeToken = (key: string) => {
  Cookies.remove(key, { domain: cookieDomain, path: '/', secure: true });
  // eslint-disable-next-line default-case
  switch (key) {
    case ACCESS_TOKEN_KEY:
      removeSessionStorageToken(STORAGE_ACCESS_TOKEN_KEY as string);
      break;
    case REFRESH_TOKEN_KEY:
      removeLocalStorageToken(STORAGE_REFRESH_TOKEN_KEY as string);
      break;
    case IMPERSONATE_ACCESS_TOKEN_KEY:
      removeSessionStorageToken(STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY as string);
      break;
    case IMPERSONATE_REFRESH_TOKEN_KEY:
      removeLocalStorageToken(STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY as string);
      break;
  }
};

export const setAccessToken = ({ key, token }: { key: string; token: string }) => {
  const maxMinutesAccessToken = new Date(Date.now() + Number(ACCESS_TOKEN_EXPIRATION_TIME));
  Cookies.set(key, token, {
    domain: cookieDomain,
    path: '/',
    sameSite: SAME_SITE_STRICT,
    secure: true,
    expires: maxMinutesAccessToken,
  });
  const storageKey: string = key === ACCESS_TOKEN_KEY ? STORAGE_ACCESS_TOKEN_KEY : STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY;
  sessionStorage.setItem(storageKey, token);
};

export const setRefreshToken = ({ key, token }: { key: string; token: string }) => {
  Cookies.set(key, token, {
    domain: cookieDomain,
    path: '/',
    sameSite: SAME_SITE_STRICT,
    secure: true,
    expires: maxDaysRefreshToken,
  });
  const storageKey: string =
    key === REFRESH_TOKEN_KEY ? STORAGE_REFRESH_TOKEN_KEY : STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY;
  localStorage.setItem(storageKey, token);
};

export const getAccessTokenFromStorage = (key: string): string | null => {
  try {
    if (globalThis.window === undefined) return null;
    return sessionStorage.getItem(key);
  } catch (_: unknown) {
    return null;
  }
};

export const getRefreshTokenFromStorage = (key: string): string | null => {
  try {
    if (globalThis.window === undefined) return null;
    return localStorage.getItem(key);
  } catch (_: unknown) {
    return null;
  }
};

export const getPublicPageToken = (key: string) => {
  try {
    return localStorage.getItem(key);
  } catch (_: unknown) {
    return null;
  }
};

export const setPublicPageToken = ({ key, token }: { key: string; token: string }) => {
  try {
    return localStorage.setItem(key, token);
  } catch (_: unknown) {
    return null;
  }
};

export const removePublicPageToken = ({ key }: { key: string }) => {
  try {
    localStorage.removeItem(key);
  } catch (_: unknown) {
    return null;
  }
};
